import React from "react";
import { Button, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export let SettingHeader = ({ headerTitle, headerDesciption, settingName, goToAccount }) => {

	return (

		<div className="setting-header">
			<h5><span onClick={goToAccount}>Account</span><i className="fa fa-angle-right"></i>{settingName}</h5>
			<h3>{headerTitle}</h3>
			<p>{headerDesciption}</p>
		</div>

	);

};

export let ShowInfoPanel = ({ ValueTitle, onEdit, infoValue, disabled }) => {

	return (

		<div>
			<div className="flex-between-center">
				<label className="title">{ValueTitle}</label>
				<button onClick={onEdit} disabled={!disabled} className="green-unfill-btn">Edit</button>
			</div>
			<p className="sub-title">{infoValue && infoValue.trim() !== "" ? infoValue : "Not provided"}</p>
		</div>

	);

};

export let DobEditInfoPanel = ({
ValueTitle,
isEditBtnHide,
onCancel,
infoValue,
onSelect,
onSave,
}) => {
return (
	<div style={{ width: "100%" }} className="ShowInfoPanel-div">
	<Col
		lg={12}
		md={12}
		sm={12}
		xs={12}
		className="ShowInfoPanel-col flex-between-center"
		style={{ marginBottom: "10px" }}
	>
		<div className="setting-title-div">{ValueTitle}</div>
		{!isEditBtnHide ? (
		<Button className="green-unfill-btn" onClick={onCancel}>
			Cancel
		</Button>
		) : (
		""
		)}
	</Col>

	<Col
		lg={12}
		md={12}
		sm={12}
		xs={12}
		className="flex-between-center datePicker-Custom-style disabled"
	>
		<DatePicker
		selected={infoValue ? new Date(new Date(infoValue).getTime()) : ""}
		onChange={(date) => onSelect(date)}
		dateFormat="dd/MM/yyyy"
		showYearDropdown
		disabled={true}
		/>
	</Col>
	<Col lg={12} md={12} sm={12} xs={12} style={{ marginTop: "10px" }}>
		{/* `<Button
		className="green-Button "
		style={{
			width: "104px",
			height: "56px",
			borderRadius: "5px",
			backgroundColor: "#2cb46d",
			fontSize: "16px",
			fontWeight: "600",
		}}
		onClick={onSave}
		>
		Save
		</Button>` */}
	</Col>
	</div>
);
};